// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_p6-0";
export var discountCodeInput = "_p6-1";